import {jwtServerInstance} from "../index";
import qs from	'qs'

export const getAllTaskType = () =>{
    return jwtServerInstance.request({
        url:'/b2ctask_type/all',
        method:'post'
    });
}
